import axios from 'axios';
import { baseAxiosInstance } from '../configuration/axiosConfig';
import { ClientResponse } from '../model/ClientResponse';
import ModulVerziaItem from '../model/ModulVerziaItem';
import { getVerzieSlovlexuZMagnolie } from './verziaSlovlexuClient';

const MODULY: { nazov: string; path?: string; url?: string; verzia?: string; buildTime?: string }[] = [
  { nazov: 'Elegislatíva', path: '/external/elegislativa/version' },
  { nazov: 'Procesný engine', path: '/internal/procesny-engine/version' },
  { nazov: 'Číselníky', path: '/external/ciselniky/version' },
  { nazov: 'Evidenčná aplikácia', path: '/external/evidencna-aplikacia/version' },
  { nazov: 'Správa pripomienok', path: '/external/sprava-pripomienok/version' },
  { nazov: 'Správa vyjadrení', path: '/external/sprava-vyjadreni/version' },
  { nazov: 'Správa aktov EÚ', path: '/external/sprava-aktov-eu/version' },
  { nazov: 'Ezbierky', url: `${process.env.REACT_APP_EZBIERKY_URL}/version.json` },
  { nazov: 'Portal main', url: `${process.env.REACT_APP_PORTAL_MAIN_URL}/version.json` },
  { nazov: 'Statický obsah', url: `${process.env.PUBLIC_URL}/version.json` },
  { nazov: 'Súdne rozhodnutia', path: '/external/sudne-rozhodnutia/version' },
  { nazov: 'Vestníky', path: '/external/vestniky/version' },
  { nazov: 'Api gateway', path: '/internal/api-gateway/version' },
  { nazov: 'Právo EÚ', path: '/external/pravo-eu/version' },
  { nazov: 'Tezaury', path: '/external/tezaury/version' },
  { nazov: 'Publikátor eZbierky', path: '/external/publikator-ezbierky/version' },
  { nazov: 'IAM-IRM', path: '/api/version' },
];

export const getVerzieModulov = async (): Promise<ClientResponse<ModulVerziaItem[]>> => {
  const fetchModuly = MODULY.filter((m) => m.verzia === undefined);

  const [settled, magnoliaItems] = await Promise.all([
    Promise.allSettled(
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      fetchModuly.map((m) => (m.url ? axios.get(m.url) : baseAxiosInstance.get(m.path!))),
    ),
    getVerzieSlovlexuZMagnolie(),
  ]);

  let fetchIndex = 0;
  const data: ModulVerziaItem[] = MODULY.map((m) => {
    if (m.verzia !== undefined) {
      return {
        nazov: m.nazov,
        verzia: m.verzia,
        buildTime: m.buildTime ?? '—',
        chyba: false,
      };
    }
    const result = settled[fetchIndex];
    fetchIndex += 1;
    if (result.status === 'fulfilled') {
      return {
        nazov: m.nazov,
        verzia: result.value.data?.version ?? '—',
        buildTime: result.value.data?.buildTime ?? '—',
        deployTime: result.value.data?.deployTime,
        chyba: false,
      };
    }
    return {
      nazov: m.nazov,
      verzia: '—',
      buildTime: '—',
      chyba: true,
    };
  });

  const anySuccess = settled.some((r) => r.status === 'fulfilled');

  return {
    data: [...data, ...magnoliaItems],
    responseCode: anySuccess ? 200 : 500,
  };
};
